(function () {

  function getBB(key) {
    return localStorage.getItem('bb_' + key) || '';
  }

  async function writeCartAttributes() {

    var clientId = getBB('ga4_client_id');

    if (!clientId) {
      console.log('No GA4 client ID yet');
      return;
    }

    var attrs = {
      ga4_client_id: clientId,
      utm_source: getBB('utm_source'),
      utm_medium: getBB('utm_medium'),
      utm_campaign: getBB('utm_campaign'),
      utm_content: getBB('utm_content'),
      utm_term: getBB('utm_term')
    };

    console.log('Writing cart attrs:', attrs);

    try {

      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: attrs
        })
      });

      console.log('Cart attributes saved');

    } catch (err) {
      console.error('Cart attribute write failed', err);
    }
  }

  window.addEventListener('load', function () {

    setTimeout(function () {
      writeCartAttributes();
    }, 2000);

  });

  document.addEventListener('click', function (e) {

    var btn = e.target.closest(
      'button[name="add"], [data-add-to-cart-text]'
    );

    if (btn) {

      setTimeout(function () {
        writeCartAttributes();
      }, 500);

    }

  });

})();